<template>
    <div :class="['cl-select', { 'cl-select-checked': isChecked }]">
        <el-popover
            placement="bottom"
            :popperClass="popperClass"
            :width="width"
            @hide="handleHide"
            trigger="click"
            v-model="visible"
        >
            <div class="cl-select-option-container">
                <!-- <div class="cl-select-all" v-if="type === 'multiple'">
                    <div class="cl-select-all-label">{{ $t('message.全选') }}</div>
                    <cl-checkbox v-model="checkAll" :key="checkAll" @change="handleCheckAllClick" />
                </div> -->
                <!-- options -->
                <div class="options-container" :key="updateKey">
                        <!-- @click="handleOptionClick(index)" -->
                    <div
                        class="cl-select-option"
                        v-for="(option, index) in options"
                        :key="option.key"
                    >
                        <div class="cl-select-option-label">
                            {{ option['value' + $lang] }}
                        </div>
                            <!-- v-if="type === 'multiple'" -->
                        <cl-checkbox
                            v-model="option.checked"
                            @change="type !== 'radio' && handleOptionCheckboxClick() || type === 'radio' && handleOptionClick(index)"
                        />
                    </div>
                </div>
            </div>
            <div class="cl-select-flag" slot="reference">
                <slot><i class="el-icon-arrow-down"></i></slot>
            </div>
        </el-popover>
    </div>
</template>
<script>
/*
    options:[
        {
            label: '内部球员',
            value: 'a',
        },
    ]
    选中状态会给options中添加checked字段并标记为true
    未选中checked为false

    每次选择会出发change事件，传入的options中的checked字段已经被标记是否选中
    this.$emit('change', options)

    单选 ---- 比多选多一个参数item（当前选中的item）
    this.$emit('change', options, item)
*/
export default {
    name: 'cl-select',
    props: {
        width: {
            type: String,
            default: 'auto',
        },
        // 多选：multiple   单选：radio
        type: {
            type: String,
            default: 'multiple',
        },
        // options
        options: {
            type: Array,
            default: () => [],
        },
        // item展示为有颜色的tags 默认false
        isTags: {
            type: Boolean,
            default: () => false,
        },
        customPopoverClass: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            checkAll: false, // 全选
            updateKey: new Date().getTime(),
            visible: false,
            defaultClass: ['ct-custom-select-popover'],
        };
    },
    computed: {
        // 如果有被选中的option 会给顶级元素添加一个class   cl-select-checked
        isChecked() {
            return !!this.options.filter((item) => item.checked).length;
        },
        popperClass() {
            return [...this.defaultClass, ...this.customPopoverClass].join(' ');
        },
    },
    methods: {
        // 全选为true时，把options中的checked都变为true
        handleCheckAllClick() {
            // 选中  or  未选中
            this.options.forEach((item) => {
                item.checked = this.checkAll;
            });
            this.updateKey = new Date().getTime();

            this.$emit('change', this.options);
        },
        // option 点击
        handleOptionCheckboxClick(checked) {
            if (!checked) {
                this.checkAll = false;
            }
            this.$emit('change', this.options);
        },

        // 单选时用到
        handleOptionClick(index) {
            if (this.type === 'radio') {
                this.$nextTick(() => {
                    // const options = this.options;
                    this.options.forEach((item, idx) => {
                        if (index !== idx) {
                            item.checked = false;
                        }
                    });
                    this.visible = false;
                    this.$emit('change', this.options, this.options[index]);
                    this.updateKey = new Date().getTime();
                })
            }
        },

        // 弹窗隐藏时触发
        handleHide() {
            this.$emit('hide', this.options);
        },
    },
};
</script>
<style lang="scss" scoped>
.cl-select {
    .cl-select-flag {
        display: flex;
        align-items: center;
        cursor: pointer;
        box-sizing: border-box;
        margin-left: 6px;
    }
}
</style>
<style lang="scss">
.ct-custom-select-popover {
    max-height: 369px;
    overflow: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    padding-bottom: 10px;
    .cl-select-option-container {

        .cl-select-all {
            margin: 0 16px;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #e4ecf5;
            padding-bottom: 5px;
            margin-bottom: 7px;
        }
        .cl-select-option {
            display: flex;
            justify-content: space-between;
            border-radius: 6px;
            padding: 12px 16px;
            transition: all 0.3s ease;
            &:hover {
                background: #f2f2f3;
            }
        }
        .cl-select-all-label,
        .cl-select-option-label {
            user-select: none;
            font-size: 14px;
            margin-right: 15px;
        }
        .cl-select-all-label {
            color: #81818a;
        }
        .cl-select-option-label {
            color: #3a3a3a;
        }
    }
}
</style>
